export default __webpack_public_path__ + "static/media/interface.fd5b90a2.svg";